import { http } from '@pendo/http';

export async function fetchSubEssentialContacts () {
    return http.get('/api/s/_SID_/essentialcontact').then((res) => res.data);
}

export async function fetchOrgEssentialContacts (orgId) {
    return http.get(`/api/organization/${orgId}/essentialcontact`).then((res) => res.data);
}

export async function createOrUpdateSubEssentialContact (contact) {
    return http.put(`/api/s/_SID_/essentialcontact/${contact.id}`, contact).then((res) => res.data);
}

export async function createOrUpdateOrgEssentialContact (orgId, contact) {
    return http.put(`/api/organization/${orgId}/essentialcontact/${contact.id}`, contact).then((res) => res.data);
}
